import { useRef, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import ScheduleActions from './Actions'
import ScheduleHeader from './Header'

export type DateRange = [Date, Date]

const HEADER_AND_ACTIONS_HEIGHT = 226

const PlanningTool = ({}) => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const [range, setRange] = useState<DateRange>([
    moment().startOf('month').toDate(),
    moment().endOf('month').toDate(),
  ])

  return (
    <>
      <Box position="sticky" style={{ top: '0', zIndex: '4', backgroundColor: '#fff' }}>
        <ScheduleActions range={range} setRange={setRange} />
      </Box>
      <Box
        overflowY="auto"
        ref={scrollRef}
        style={{ maxHeight: `calc(100vh - ${HEADER_AND_ACTIONS_HEIGHT}px)` }}
      >
        <ScheduleHeader range={range} />
      </Box>
    </>
  )
}

export default PlanningTool
